<template>
  <div>
    <h5 style="text-align:center;">撤销上传操作 —— 证明开具</h5>

    <!-- 日志表 -->
    <el-table :data="logs" border style="width:100%">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="datetime_cn" label="上传时间" />
      <el-table-column prop="uuid" label="UUID" />

      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button
            size="small"
            type="primary"
            @click="viewDetail(scope.row.uuid)"
          >
            查看详情
          </el-button>

          <el-button
            size="small"
            type="danger"
            @click="confirmDelete(scope.row.uuid)"
          >
            撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 详情弹窗 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="上传内容详情"
      width="90%"
    >
      <el-tabs v-model="activeTab">
        <el-tab-pane label="校级开课" name="course">
          <el-table
            :data="detailData.school_course_summary"
            border
            style="width:100%"
          >
            <el-table-column prop="subject" label="学科" />
            <el-table-column prop="topic" label="课题" />
            <el-table-column prop="teacher" label="执教者" />
            <el-table-column prop="level" label="级别" />
            <el-table-column prop="mentor" label="指导教师" />
                  <el-table-column label="日期" width="100">
        <template #default="scope">
          <div v-if="editMode">
            <el-input v-model="scope.row.year" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.month" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.day" size="small" style="width: 50px; display: inline-block;"></el-input>
          </div>
          <span v-else>{{ scope.row.year }}/{{ scope.row.month }}/{{ scope.row.day }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="remark" label="备注" />
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="校级讲座" name="lecture">
          <el-table
            :data="detailData.school_lecture"
            border
            style="width:100%"
          >
            <el-table-column prop="subject" label="学科" />
            <el-table-column prop="topic" label="课题" />
            <el-table-column prop="teacher" label="执教者" />
            <el-table-column prop="mentor" label="指导教师" />
                  <el-table-column label="日期" width="100">
        <template #default="scope">
          <div v-if="editMode">
            <el-input v-model="scope.row.year" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.month" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.day" size="small" style="width: 50px; display: inline-block;"></el-input>
          </div>
          <span v-else>{{ scope.row.year }}/{{ scope.row.month }}/{{ scope.row.day }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="level" label="级别" />
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="校级主备" name="preparation">
          <el-table
            :data="detailData.school_preparation_summary"
            border
            style="width:100%"
          >
            <el-table-column prop="subject" label="学科" />
            <el-table-column prop="topic" label="课题" />
            <el-table-column prop="teacher" label="执教者" />
            <el-table-column prop="mentor" label="指导教师" />
                  <el-table-column label="日期" width="100">
        <template #default="scope">
          <div v-if="editMode">
            <el-input v-model="scope.row.year" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.month" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.day" size="small" style="width: 50px; display: inline-block;"></el-input>
          </div>
          <span v-else>{{ scope.row.year }}/{{ scope.row.month }}/{{ scope.row.day }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="remark" label="备注" />
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="跟岗实践" name="internship">
          <el-table
            :data="detailData.internship_certificate"
            border
            style="width:100%"
          >
            <el-table-column prop="subject" label="学科" />
            <el-table-column prop="topic" label="内容" />
            <el-table-column prop="teacher" label="执教者" />
            <el-table-column prop="mentor" label="指导教师" />
                  <el-table-column label="日期" width="100">
        <template #default="scope">
          <div v-if="editMode">
            <el-input v-model="scope.row.year" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.month" size="small" style="width: 50px; display: inline-block;"></el-input>/
            <el-input v-model="scope.row.day" size="small" style="width: 50px; display: inline-block;"></el-input>
          </div>
          <span v-else>{{ scope.row.year }}/{{ scope.row.month }}/{{ scope.row.day }}</span>
        </template>
      </el-table-column>
            <el-table-column prop="remark" label="备注" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'UploadLog',

  data() {
    return {
      logs: [],
      detailDialogVisible: false,
      activeTab: 'course',
      detailData: {
        school_course_summary: [],
        school_lecture: [],
        school_preparation_summary: [],
        internship_certificate: []
      }
    }
  },

  mounted() {
    this.fetchLogs()
  },

  methods: {
    formatChineseDatetime(dtString) {
      const dt = new Date(dtString)
      if (isNaN(dt)) return dtString

      const Y = dt.getFullYear()
      const M = String(dt.getMonth() + 1).padStart(2, '0')
      const D = String(dt.getDate()).padStart(2, '0')
      const h = String(dt.getHours()).padStart(2, '0')
      const m = String(dt.getMinutes()).padStart(2, '0')
      const s = String(dt.getSeconds()).padStart(2, '0')

      return `${Y}年${M}月${D}日 ${h}:${m}:${s}`
    },

    fetchLogs() {
      axios.get('/api/logs')
        .then(res => {
          this.logs = res.data.map(item => ({
            ...item,
            datetime_cn: this.formatChineseDatetime(item.datetime)
          }))
        })
        .catch(() => {
          ElMessage.error('获取日志失败')
        })
    },

    viewDetail(uuid) {
      axios.get(`/api/logs/${uuid}/detail`)
        .then(res => {
          this.detailData = res.data
          this.activeTab = 'course'
          this.detailDialogVisible = true
        })
        .catch(() => {
          ElMessage.error('获取详情失败')
        })
    },

    confirmDelete(uuid) {
      ElMessageBox.confirm(
        '确定要撤销本次上传吗？所有关联数据将被删除。',
        '确认撤销',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.deleteLog(uuid)
      })
    },

    deleteLog(uuid) {
      axios.delete(`/api/logs/${uuid}`)
        .then(() => {
          ElMessage.success('撤销成功')
          this.fetchLogs()
        })
        .catch(() => {
          ElMessage.error('撤销失败')
        })
    }
  }
}
</script>
